<template>
    <section class="p-4 border-top" aria-labelledby="prescripteurs-activation-title">
        <h3 id="prescripteurs-activation-title">Commissions des prescripteurs</h3>
        <p>Activer le choix du prescripteur en caisse et le calcul de ses commissions par catégorie de prestation.</p>
        <p class="text-muted">La désactivation conserve les fiches et les commissions déjà acquises. La réactivation ne recalcule pas les anciennes opérations.</p>
        <p v-if="erreur" role="alert" class="text-danger">{{ erreur }}</p>
        <router-link v-if="connexionRequise" to="/login" class="btn btn-outline-primary mb-3">Se reconnecter</router-link>
        <p v-if="message" role="status" class="text-success">{{ message }}</p>
        <fieldset :disabled="!pret || chargement || sauvegarde">
            <legend class="font-18">Activer les commissions des prescripteurs</legend>
            <label class="mr-5"><input type="radio" v-model="active" :value="true" name="prescripteurs-activation"> Oui</label>
            <label><input type="radio" v-model="active" :value="false" name="prescripteurs-activation"> Non</label>
        </fieldset>
        <div class="text-right">
            <button v-if="!pret && !chargement" class="btn btn-outline-primary mr-2" @click="charger">Réessayer</button>
            <button class="btn btn-primary btn-radius" :disabled="!pret || chargement || sauvegarde" @click="enregistrer">{{ sauvegarde ? 'Enregistrement…' : 'Enregistrer les commissions' }}</button>
        </div>
    </section>
</template>
<script>
import api from '@/api/_prescripteurs'
export default {
    data: () => ({ active: false, pret: false, chargement: false, sauvegarde: false, erreur: '', message: '', connexionRequise: false }),
    mounted() { this.charger() },
    methods: {
        async charger() {
            this.chargement = true; this.erreur = ''; this.message = ''; this.pret = false; this.connexionRequise = false
            try { const result = await api.activation(await api.access()); this.active = result.active === true; this.pret = true }
            catch (error) { this.afficherErreur(error, 'Impossible de charger le paramètre des commissions. Réessayez.') }
            finally { this.chargement = false }
        },
        async enregistrer() {
            if (!this.pret || this.sauvegarde) return
            this.sauvegarde = true; this.erreur = ''; this.message = ''
            try { const result = await api.activer(this.active, await api.access()); this.active = result.active; this.message = this.active ? 'Commissions activées.' : 'Commissions désactivées. Historique conservé.' }
            catch (error) { this.afficherErreur(error, 'Le paramètre n’a pas été enregistré. Réessayez.') }
            finally { this.sauvegarde = false }
        },
        afficherErreur(error, message) {
            const status = error.response && error.response.status
            this.connexionRequise = status === 401
            this.message = ''
            if (status === 401 || status === 403) this.pret = false
            this.erreur = status === 401 ? 'Votre session a expiré. Reconnectez-vous pour charger et enregistrer ce paramètre.'
                : status === 403 ? 'Un accès administrateur est requis pour ce paramètre.' : message
        }
    }
}
</script>
